var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"u-radio-button-container"},[_c('div',{class:['u-radio-button', {'selected' : _vm.selected}]},[(_vm.selected)?_c('div',{staticClass:"center"}):_vm._e()]),(_vm.label)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.label)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }